// extracted by mini-css-extract-plugin
module.exports = {"fee":"fee_VnivC","icon":"icon_3SvF3"};